import { createSelector } from '@reduxjs/toolkit';

const getState = (state) => state.issuerCoverageBuilder;

export const issuerCoverageSelector = createSelector(getState, (state) => state.coverage);
